import React from 'react';
import { Info as LucideInfo } from 'lucide-react';

interface InfoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Info: React.FC<InfoProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideInfo width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Info;
